module.exports = {
  "metadata": {
    "width": "16",
    "height": "24",
    "name": "delete"
  },
  "source": "<path d=\"M2 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H2zM15 4h-3.5l-1-1h-5l-1 1H1v2h14z\"/>"
};